export const checkIsPhone = (value: string): boolean => {
  if (typeof value !== 'string') return false;

  const input = value.trim();
  if (input === '') return false;

  const digits = input.replace(/\D/g, '');

  // Russian E.164: +7 followed by 10 digits (total 11 digits without '+')
  if (input.startsWith('+7')) {
    return digits.length === 11;
  }

  // Generic E.164: starts with '+' and has 8–15 digits (excluding '+')
  if (input.startsWith('+')) {
    const digitsWithoutPlus = input.slice(1).replace(/\D/g, '');
    return digitsWithoutPlus.length >= 8 && digitsWithoutPlus.length <= 15;
  }

  // Local formats without '+': accept 11 digits starting with 7 or 8 (common RU patterns)
  if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    return true;
  }

  return false;
};
